import { FeeConfigs } from '../const/products/vod-assessment';
import numeral from 'numeral';
/**
 * 1、todo 低频操作，以后需要维护在 kconf
 * 2、计算价格时，各场景档位枚举值
 */
const assessmentConfig = {
  UGC: {
    origin: {
      H264: ['1080P', '720P', '540P', '480P'],
      H265: ['1080P', '720P', '540P', '480P'],
    },
    target: {
      H264: ['1080P', '720P', '540P', '480P'],
      H265: ['1080P', '720P', '540P', '480P'],
    },
  },
  PGC: {
    origin: {
      H264: ['1080P', '720P', '540P', '480P'],
      H265: ['1080P', '720P', '540P', '480P'],
    },
    target: {
      H264: ['1080P', '720P', '540P', '480P'],
      H265: ['1080P', '720P', '540P', '480P'],
    },
  },
  image: {
    origin: {
      H264: ['540P'],
      H265: ['540P'],
    },
    target: {
      H264: ['540P'],
      H265: ['540P'],
    },
  },
};

/**
 * todo 用更好的方式维护map
 * 维护计费项目和计费单价之间的关系，通过metaFeeItemCode，找到对应的价格
 * metaFeeItem 可以从运营支撑系统-计费项配置中获取
 */
const metaFeeItemCodes = {
  zzql: '045fccb975c42a01',
  transcode: '04599981b3ce454d',
  flow: '045fcef42b1390ds',
  bandwidthMonth95: '045fcef42b9274px',
  storage: '045fcf7cbec42730',
};

/**
 * 方案一总费用 = 转码服务费用 + 媒资存储服务费用 + CDN分发加速费用
 * @param scene 视频场景
 * @param targetQuality 目标画质
 * @param originQuality 原始画质
 * @param param 业务数据
 * @param videoConfigs 视频配置数据
 */
export function schemeOneTotalCost(
  scene,
  targetQuality,
  originQuality,
  { videoNumber, videoDuration, monthBandWidth95, flow, feeType },
  videoConfigs
) {
  const feeConfigs = FeeConfigs.vod.feeItems;
  // 转码
  const transcodeRes = transcodeCost(
    scene,
    targetQuality,
    originQuality,
    { videoNumber, videoDuration },
    feeConfigs
  );

  // 各码率
  const { bitRate, targetBitRates, originBitRates } = getBitRates(
    scene,
    targetQuality,
    originQuality,
    videoConfigs
  );
  // 存储
  const storageRes = storageCost(
    { videoNumber, videoDuration },
    { bitRate, targetBitRates, originBitRates },
    feeConfigs
  );

  // 分发加速
  // 转码压缩率下降
  const transcodeCompress = transcodeCompressRate(
    bitRate,
    targetBitRates,
    originBitRates
  );
  const cdnRes = cdnUsageCost(
    { monthBandWidth95, flow, feeType },
    transcodeCompress,
    feeConfigs
  );
  return {
    transcode: transcodeRes,
    storage: storageRes,
    cdn: cdnRes,
  };
}

/**
 * 方案二总费用 = 归一化系数 X CDN用量 X（1-转码压缩率） X CDN单价
 * 获取归一化系数 和 转码压缩率
 */

export function getScale(scene, targetQuality, originQuality, videoConfigs) {
  const { bitRate, targetBitRates, originBitRates } = getBitRates(
    scene,
    targetQuality,
    originQuality,
    videoConfigs
  );
  const transcodeCompress = transcodeCompressRate(
    bitRate,
    targetBitRates,
    originBitRates
  );
  const scale = 1 / (1 - transcodeCompress);
  return { scale, transcodeCompress };
}

/**
 * 转码费用
 */
function transcodeCost(
  scene,
  targetQuality,
  originQuality,
  { videoNumber, videoDuration },
  feeConfigs
) {
  const currentAssessmentConfig = assessmentConfig[scene];
  const targetResolutions = currentAssessmentConfig.target[targetQuality];
  const originResolutions = currentAssessmentConfig.origin[originQuality];
  // 业务数据
  const videoData = videoNumber * videoDuration; // 单位Min
  // 原始费用
  const originFeeConfig = feeConfigs.find(
    (item) => item.metaFeeItemCode === metaFeeItemCodes.transcode
  );

  const originCost = getQualityTranscodeConst(
    originResolutions,
    originQuality,
    videoData,
    originFeeConfig
  );
  // 目标费用
  const targetFeeConfig = feeConfigs.find(
    (item) => item.metaFeeItemCode === metaFeeItemCodes.zzql
  );
  const targetCost = getQualityTranscodeConst(
    targetResolutions,
    targetQuality,
    videoData,
    targetFeeConfig
  );
  return { originCost, targetCost };
}

/**
 * 计算指定画质的转码费用
 * @param resolutions
 * @param quality
 * @param videoData
 * @param feeData
 */
function getQualityTranscodeConst(
  resolutions: string[],
  quality: string,
  videoData: number,
  feeData
) {
  if (feeData && feeData.feeType === 'static') {
    // 只计算固定单价
    const feeConfig = feeData.dsls;
    let total = 0;
    const usefulConfigs = feeConfig
      .filter((item) => {
        const factor = item.factors.find((el) => el.type === 'codeType');
        return factor.val === quality;
      })
      .reduce((res, item) => {
        const transcodeType = item.factors.find(
          (factor) => factor.type === 'transcodeType'
        )?.val;
        res[transcodeType] = item.price.static;
        return res;
      }, {});
    resolutions.forEach((item) => {
      total += usefulConfigs[item] * videoData;
    });
    return total;
  }
}
/**
 * 存储费用
 */
function storageCost(
  { videoNumber, videoDuration },
  { bitRate, targetBitRates, originBitRates },
  feeConfigs
) {
  const videoData = videoNumber * videoDuration * 60; // 单位s
  // 只统计标准存储
  const feeConfig = feeConfigs
    .find((item) => item.metaFeeItemCode === metaFeeItemCodes.storage)
    .dsls.find((item) =>
      item.factors.find((factor) => factor.val === '标准存储')
    );
  // console.log(feeConfig);
  const originCost = getQualityStorageCost(
    bitRate,
    originBitRates,
    videoData,
    feeConfig
  );
  const targetCost = getQualityStorageCost(
    bitRate,
    targetBitRates,
    videoData,
    feeConfig
  );
  return { originCost, targetCost };
}
/**
 * 计算指定画质的存储费用
 * @param bitRate
 * @param outputBitRates
 * @param videoData
 * @param feeData
 */
function getQualityStorageCost(bitRate, outputBitRates, videoData, feeData) {
  const totalBitRate =
    outputBitRates.reduce((total, item) => (total += item), 0) + bitRate;
  // kbps 转 存储GB
  const cost =
    ((videoData * totalBitRate) / 1024 / 1024 / 8) * feeData.price.static;
  return cost;
}

function cdnUsageCost(
  { monthBandWidth95, flow, feeType },
  bitRateCompress,
  feeConfigs
) {
  // 流量计费
  if (feeType === 'flow') {
    const price = feeConfigs.find(
      (item) => item.metaFeeItemCode === metaFeeItemCodes.flow
    ).dsls[0].price.static;
    const originCost = flow * price;
    const targetCost = originCost * (1 - bitRateCompress);
    return { originCost, targetCost };
  } else {
    // 月95
    const price = feeConfigs.find(
      (item) => item.metaFeeItemCode === metaFeeItemCodes.bandwidthMonth95
    ).dsls[0].price.static;
    const originCost = monthBandWidth95 * price;
    const targetCost = originCost * (1 - bitRateCompress);
    return { originCost, targetCost };
  }
}

/**
 * 转码压缩率下降
 * @param bitRate
 * @param targetBitRates
 * @param originBitRates
 * @returns
 */
export function transcodeCompressRate(
  bitRate: number,
  targetBitRates: number[],
  originBitRates: number[]
) {
  const originTotal = originBitRates.reduce(
    (total, item) => (total += item),
    0
  );
  const targetTotal = targetBitRates.reduce(
    (total, item) => (total += item),
    0
  );
  return (originTotal - targetTotal) / originTotal;
}

/**
 * 媒资存储用量下降
 * @param bitRate
 * @param targetBitRates
 * @param originBitRates
 * @returns
 */
export function storageUsageRate(
  bitRate: number,
  targetBitRates: number[],
  originBitRates: number[]
) {
  const originTotal = originBitRates.reduce(
    (total, item) => (total += item),
    0
  );
  const targetTotal = targetBitRates.reduce(
    (total, item) => (total += item),
    0
  );
  return (originTotal - targetTotal) / (bitRate + originTotal);
}

/**
 * 格式化百分数
 * @param val
 * @param precision
 * @param withUnit
 */
export function formatPercentNumber(
  val: number,
  precision = 0,
  withUnit = false
) {
  // NaN特殊处理
  if (isNaN(val)) {
    val = 0;
  }
  const res = (val * 100).toFixed(precision);
  if (withUnit) {
    return res + '%';
  }
  return res;
}
/**
 * 格式化费用 以元为单位
 * @param val
 * @returns
 */
export function formatCost(val) {
  return numeral(val).format('0,0');
  // const res = formatCostUnit(val, 0);
  // return res;
}
/**
 * 转换价钱单位
 * @param val
 * @param precision
 * @returns
 */
export function formatCostUnit(val, precision = 2) {
  const units = [
    '',
    '万',
    '亿',
    '万亿',
    '京',
    '垓',
    '秭',
    '穰',
    '沟',
    '涧',
    '正',
    '载',
  ];
  const isPositive = val >= 0;
  let res = isPositive ? val : val * -1;
  let index = 0;
  while (res >= 10000) {
    index++;
    res = parseFloat((res / 10000).toFixed(2));
  }
  return (
    (!isPositive && '-') + parseFloat(res?.toFixed(precision)) + units[index]
  );
}
/**
 * 将月数转为年
 * @param month
 * @returns
 */
export function translateMonthToYear(month) {
  return parseFloat((month / 12).toFixed(2));
}
/**
 * 将年转为月份
 * @param month
 * @returns
 */
export function translateYearToMonth(year) {
  const yearNum = Math.floor(year);
  const monthNum = Math.round((year % 1) * 12);
  let res = '';
  if (yearNum) {
    res += `${yearNum}年`;
  }
  if (monthNum) {
    res += `${monthNum}个月`;
  }
  return res;
}

export function sceneFilter(scene) {
  switch (scene) {
    case 'PGC':
      return '短视频-PGC';
    case 'UGC':
      return '短视频-UGC';
    case 'image':
      return '图片电影';
    default:
      return scene;
  }
}
/**
 * 获取视频码率
 * @param scene
 * @param targetQuality
 * @param originQuality
 * @param videoConfigs
 * @returns
 */
export function getBitRates(scene, targetQuality, originQuality, videoConfigs) {
  const type = sceneFilter(scene);
  const { sourceUrls } = videoConfigs.find((item) => item.name === type);
  const bitRate = sourceUrls.find((item) => item.type === 'origin').configs[0]
    .bitRate;
  const targetBitRates = sourceUrls.find((item) => item.type === 'zzql')?.[
    `${targetQuality}bitRate`
  ];
  const originBitRates = sourceUrls.find((item) => item.type === 'common')?.[
    `${originQuality}bitRate`
  ];
  return { bitRate, targetBitRates, originBitRates };
}
